import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function GoogleYouTubeCallback() {
  const navigate = useNavigate();
  const ran = useRef(false);
  const [msg, setMsg] = useState("Verifying your YouTube channel…");

  useEffect(() => {
    if (ran.current) { return; }
    ran.current = true;
    const p = new URLSearchParams(window.location.search);
    const code = p.get("code");
    const state = p.get("state");
    if (!code || !state) {
      toast.error("YouTube verification was cancelled.");
      navigate("/profile", { replace: true });
      return;
    }
    api.post("/social/youtube/oauth/exchange", { code, state })
      .then(({ data }) => { toast.success(`YouTube ownership verified — ${data.title}`); navigate("/profile?yt=connected", { replace: true }); })
      .catch((e) => { setMsg("Verification failed."); toast.error(e?.response?.data?.detail || "YouTube verification failed."); navigate("/profile", { replace: true }); });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center gap-3 text-muted-foreground" data-testid="youtube-oauth-callback">
      <Loader2 className="h-5 w-5 animate-spin" /> {msg}
    </div>
  );
}
